import { Link } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { SeoHead } from "@/components/seo/SeoHead";
import { StructuredData } from "@/components/seo/StructuredData";
import { getBaseUrl, buildBreadcrumbSchema } from "@/lib/seo";

const SEGURANCA_TITLE = "Segurança e LGPD | FabChat";
const SEGURANCA_DESCRIPTION =
  "Segurança e LGPD na FabChat: como tratamos dados de atendimento em WhatsApp e Instagram e onde consultar políticas de privacidade, termos e cookies.";

const breadcrumbItems = [
  { name: "Início", path: "/" },
  { name: "Segurança e LGPD", path: "/seguranca-lgpd" },
];

export default function SegurancaLgpd() {
  const baseUrl = getBaseUrl();
  const breadcrumbSchema = buildBreadcrumbSchema(baseUrl, breadcrumbItems);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SeoHead
        title={SEGURANCA_TITLE}
        description={SEGURANCA_DESCRIPTION}
        canonicalPath="/seguranca-lgpd"
      />
      <StructuredData data={breadcrumbSchema} />
      <Header />

      <main className="flex-1">
        <section className="container mx-auto px-4 py-16 md:py-24 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Segurança e LGPD</h1>
          <p className="text-lg text-muted-foreground mb-12">
            Nossa abordagem institucional à privacidade, à proteção de dados e ao tratamento de informações na plataforma.
          </p>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-4">Compromisso com a privacidade</h2>
            <p className="text-muted-foreground mb-4">
              A FabChat leva a privacidade e a proteção de dados a sério. Tratamos as informações de usuários e de leads de acordo com práticas transparentes e em alinhamento com a Lei Geral de Proteção de Dados (LGPD - Lei 13.709/2018). As finalidades de uso dos dados, os direitos dos titulares e as bases legais estão descritos em nossos documentos oficiais.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-4">Tratamento de dados na plataforma</h2>
            <p className="text-muted-foreground mb-4">
              Na operação da plataforma, coletamos e processamos apenas os dados necessários para prestar o serviço: cadastro de usuários, configuração de agentes, conversas e dados de leads para atendimento e CRM. Os dados são utilizados para fins de operação do produto, suporte e cumprimento de obrigações legais, conforme detalhado na nossa Política de Privacidade.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-4">Direitos do titular e transparência</h2>
            <p className="text-muted-foreground mb-4">
              Respeitamos os direitos previstos na LGPD, como acesso, correção, exclusão e portabilidade dos dados, na medida em que se aplicam ao nosso serviço. As formas de exercer esses direitos e de entrar em contato conosco para questões de privacidade estão descritas na Política de Privacidade e nos Termos de Serviço.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-semibold mb-4">Documentos de referência</h2>
            <p className="text-muted-foreground mb-4">
              Para detalhes completos sobre coleta, uso, armazenamento e compartilhamento de dados, consulte:
            </p>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link to="/privacidade" className="text-primary hover:underline font-medium">
                  Política de Privacidade
                </Link>
                — como coletamos, usamos e protegemos seus dados.
              </li>
              <li>
                <Link to="/termos" className="text-primary hover:underline font-medium">
                  Termos de Serviço
                </Link>
                — condições de uso da plataforma e obrigações das partes.
              </li>
              <li>
                <Link to="/cookies" className="text-primary hover:underline font-medium">
                  Política de Cookies
                </Link>
                — uso de cookies e tecnologias similares no site.
              </li>
            </ul>
          </section>

          <p className="text-sm text-muted-foreground pt-4">
            Em caso de dúvidas sobre segurança ou tratamento de dados, entre em contato pelos canais indicados na página de <Link to="/contato" className="text-primary hover:underline">Contato</Link>.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
}
